import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!/^(http|https):/i.test(request.url)) {
      if (request.url.startsWith('/org')) {
        request = this.getOriginalUrl(request);
      } else {
        request = request.clone({ url: environment.serverUrl + request.url });
      }
    }
    return next.handle(request);
  }

  /**
   * Map the url prefix to the original url.
   * @param request incoming Http Request
   * @returns HttpRequest with the original url
   */
  private getOriginalUrl(request: HttpRequest<unknown>): HttpRequest<unknown> {
    /**
     * incoming url expected to be in format /org/{{service name}}
     * will split the url by '/'
     * first element in the string array should be ''
     * second element in the string array should be 'org'
     * third element should be 'service Name'
     */

    const requestPaths = request.url.split('/').slice(1);

    const prefixApiMap = {
      sku: environment.skuUrl,
      vs: environment.vsUrl,
      delivery: environment.deliveryUrl,
      merchant: environment.merchantUrl,
      transactions: environment.transactionsUrl,
      profile: environment.profileUrl,
      token: environment.ahoyAuthUrl,
      refreshToken: environment.refreshTokenUrl,
      auth: environment.authAuthApi,
      google: environment.googlePlacesUrl,
      hadir: environment.hadirUrl,
      hadirSms: environment.hadirSmsUrl,
      sgs: environment.sgsCustomerUrl,
    };

    if (
      requestPaths.length < 1 ||
      requestPaths[0] !== 'org' ||
      !prefixApiMap[requestPaths[1] as keyof typeof prefixApiMap]
    ) {
      // invalid request
      return request;
    }

    if (request.url.startsWith('/org/token')) {
      request = request.clone({
        url:
          environment.ahoyAuthUrl +
          request.url.replace(
            '/org/token',
            `/${environment.activeDirectoryUrl}`,
          ),
      });
    } else if (request.url.startsWith('/org/refreshToken')) {
      request = request.clone({
        url:
          environment.ahoyAuthUrl +
          request.url.replace(
            '/org/refreshToken',
            `/${environment.refreshTokenUrl}`,
          ),
      });
    } else {
      request = request.clone({
        url:
          prefixApiMap[requestPaths[1] as keyof typeof prefixApiMap] +
          request.url.replace(`/org/${requestPaths[1]}`, ''),
      });
    }

    return request;
  }
}
